import { render } from "./HistoryPage.vue?vue&type=template&id=15280a90&scoped=true&ts=true"
import script from "./HistoryPage.vue?vue&type=script&lang=ts"
export * from "./HistoryPage.vue?vue&type=script&lang=ts"

import "./HistoryPage.vue?vue&type=style&index=0&id=15280a90&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15280a90"]])

export default __exports__